import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import {
  faAngleDown, faAngleUp, faAngleDoubleLeft, faAngleLeft, faAngleRight, faAngleDoubleRight
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'fs-pagination',
  styleUrls: ['./pagination.sass'],
  templateUrl: './pagination.component.html'
})

export class PaginationComponent {
  @Input() id: string;
  @Input() currentPage: number;

  _totalPages: any[];

  @Input() set totalPages(t: any[]) {
    if (t !== undefined) {
      this._totalPages = t;
    }
    this.repaginate();
  }

  get totalPages(): any[] {
    return this._totalPages;
  }

  @Input() totalEntries: number = 0;

  @Input() maxSize: number = 10;
  @Input() listSizeItemsPerPage: Array<number> = [10, 20, 30];

  @Input() nameItemPage: string = 'des éléments\'';

  @Input() rotate: boolean = false;
  @Input() callback: any;

  @Output() pageAsked: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() changeSizePage: EventEmitter<number> = new EventEmitter<number>();

  private FIRST_PAGE: number = 0;
  private LAST_PAGE: number = 11;
  private PAS_INCREMENTAL: number = 6;
  private startPage: number = 0;
  private endPage: number = 11;

  // fontawesome icons
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faAngleDoubleRight = faAngleDoubleRight;

  dropDownIsActive: boolean = false;

  constructor() { }

  getFirst(event: Event): void {
    this.getPage(event, this.currentPage = this.FIRST_PAGE);
  }

  getPrevious(event: Event): void {
    this.getPage(event, --this.currentPage);
  }

  getNext(event: Event): void {
    this.getPage(event, ++this.currentPage);
  }

  getLast(event: Event): void {
    this.getPage(event, this.currentPage = this.totalPages.length - 1);
  }

  getPage(event: Event, pageNumber: number): void {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    this.currentPage = pageNumber;
    this.pageAsked.emit(this.prepareCallback(pageNumber));
    this.repaginate();
  }

  getPageSelect(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.pageAsked.emit(this.prepareCallback(pageNumber));
    this.repaginate();
  }

  toggleActive($event: Event) {
    $event.stopPropagation();
    this.dropDownIsActive = true;
  }

  selectSizePage($event: Event, sizePage: number): void {
    $event.preventDefault();
    this.changeSizePage.emit(sizePage);
    this.currentPage = this.FIRST_PAGE;
    this.dropDownIsActive = false;
  }

  @HostListener('document:click', ['$event.target'])
  onClick() {
    if (this.dropDownIsActive) {
      this.dropDownIsActive = false;
    }
  }

  private repaginate() {
    if (this.currentPage <= this.PAS_INCREMENTAL || this.totalPages.length <= this.LAST_PAGE) { // limite démarrage
      this.startPage = this.FIRST_PAGE;
      this.endPage = this.LAST_PAGE;
    } else if ((this.currentPage + this.PAS_INCREMENTAL) >= this.totalPages.length) { // limite finale
      // this.startPage = this.currentPage - this.PAS_INCREMENTAL*2 +1;
      this.endPage = this.totalPages.length;
      this.startPage = this.endPage - this.PAS_INCREMENTAL * 2 + 1;
    } else { // cas courant - milieu de la liste
      this.startPage = this.currentPage - this.PAS_INCREMENTAL;
      this.endPage = this.currentPage + this.PAS_INCREMENTAL - 1;
    }
  }

  private prepareCallback(pageNumber: number) {
    const params = [];
    params.push(pageNumber);
    params.push(this.callback);
    return params;
  }

}
